import dashboardService from "../../../services/dashboardService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_GETCLOSEDTICKETSBYMONTH } from "../../../utils/constants";
import { TicketsByMonth } from "../../../models/Dashboard";

const useGetClosedTicketsByMonth = (year: number) =>
  useQuery<TicketsByMonth[], Error>({
    queryKey: [CACHE_KEY_GETCLOSEDTICKETSBYMONTH, year],
    queryFn: () => dashboardService.GetClosedTicketByMonth(year),
  });

export default useGetClosedTicketsByMonth;
